import {
  LOAD_VIDEOS_PENDING,
  LOAD_VIDEOS_FULFILLED,
  LOAD_VIDEOS_REJECTED,
  LOAD_NEW_VIDEOS_PENDING,
  LOAD_NEW_VIDEOS_FULFILLED,
  LOAD_NEW_VIDEOS_REJECTED,
  LOAD_VIDEOS_UPLOAD_PENDING,
  LOAD_VIDEOS_UPLOAD_FULFILLED,
  LOAD_VIDEOS_UPLOAD_REJECTED,
  LOAD_NEW_VIDEOS_UPLOAD_PENDING,
  LOAD_NEW_VIDEOS_UPLOAD_FULFILLED,
  LOAD_NEW_VIDEOS_UPLOAD_REJECTED,
  LOAD_VIDEO_MODELS_PENDING,
  LOAD_VIDEO_MODELS_FULFILLED,
  LOAD_VIDEO_MODELS_REJECTED,
  LOAD_VIDEO_CATEGORIES_PENDING,
  LOAD_VIDEO_CATEGORIES_FULFILLED,
  LOAD_VIDEO_CATEGORIES_REJECTED,
  LOAD_VIDEO_LANGUAGES_PENDING,
  LOAD_VIDEO_LANGUAGES_FULFILLED,
  LOAD_VIDEO_LANGUAGES_REJECTED,
  LOAD_ADMIN_VIDEO_CATEGORIES_PENDING,
  LOAD_ADMIN_VIDEO_CATEGORIES_FULFILLED,
  LOAD_ADMIN_VIDEO_CATEGORIES_REJECTED,
  LOAD_ADMIN_VIDEO_TYPES_PENDING,
  LOAD_ADMIN_VIDEO_TYPES_FULFILLED,
  LOAD_ADMIN_VIDEO_TYPES_REJECTED,
  POST_VIDEO_PENDING,
  POST_VIDEO_FULFILLED,
  POST_VIDEO_REJECTED,
  PUT_VIDEO_PENDING,
  PUT_VIDEO_FULFILLED,
  PUT_VIDEO_REJECTED,
  DELETE_VIDEO_PENDING,
  DELETE_VIDEO_FULFILLED,
  DELETE_VIDEO_REJECTED,
  CLEAR_VIDEOS_MESSAGES,
} from '../actions/videos'
import i18n from 'i18next'

export default function videos(state = {}, action) {
  switch (action.type) {
    case LOAD_VIDEOS_PENDING:
    case LOAD_NEW_VIDEOS_PENDING:
    case LOAD_VIDEOS_UPLOAD_PENDING:
    case LOAD_NEW_VIDEOS_UPLOAD_PENDING:
    case LOAD_VIDEO_MODELS_PENDING:
    case LOAD_VIDEO_CATEGORIES_PENDING:
    case LOAD_ADMIN_VIDEO_CATEGORIES_PENDING:
    case LOAD_ADMIN_VIDEO_TYPES_PENDING:
    case POST_VIDEO_PENDING:
    case PUT_VIDEO_PENDING:
    case DELETE_VIDEO_PENDING:
    case LOAD_VIDEO_LANGUAGES_PENDING:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      }
    case LOAD_VIDEOS_REJECTED:
    case LOAD_NEW_VIDEOS_REJECTED:
    case LOAD_VIDEOS_UPLOAD_REJECTED:
    case LOAD_NEW_VIDEOS_UPLOAD_REJECTED:
    case LOAD_VIDEO_MODELS_REJECTED:
    case LOAD_VIDEO_CATEGORIES_REJECTED:
    case LOAD_ADMIN_VIDEO_CATEGORIES_REJECTED:
    case LOAD_ADMIN_VIDEO_TYPES_REJECTED:
    case POST_VIDEO_REJECTED:
    case PUT_VIDEO_REJECTED:
    case DELETE_VIDEO_REJECTED:
    case LOAD_VIDEO_LANGUAGES_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: i18n.t([`error.${action.payload.response?.data?.code}`, 'error.something_wrong']),
      }
    case LOAD_VIDEOS_FULFILLED:
      const videos = state?.videos || []
      const newVideosIds = action.payload.data?.map((item) => item.id)
      const difference = videos.filter((x) => !newVideosIds.includes(x.id)).concat(action.payload.data)
      return {
        ...state,
        videos: difference,
        canLoadMore: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_NEW_VIDEOS_FULFILLED:
      return {
        ...state,
        videos: action.payload.data,
        canLoadMore: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_VIDEOS_UPLOAD_FULFILLED:
      const videosUpload = state?.videosUpload || []
      const newVideosUploadIds = action.payload.data?.map((item) => item.id)
      const videosUploadDifference = videosUpload.filter((x) => !newVideosUploadIds.includes(x.id)).concat(action.payload.data)

      return {
        ...state,
        videosUpload: videosUploadDifference,
        canLoadMoreVideosUpload: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_NEW_VIDEOS_UPLOAD_FULFILLED:
      return {
        ...state,
        videosUpload: action.payload.data,
        canLoadMoreVideosUpload: action.payload.nextPage,
        isLoading: false,
      }
    case LOAD_VIDEO_MODELS_FULFILLED:
      return {
        ...state,
        models: action.payload.data,
        isLoading: false,
      }
    case LOAD_VIDEO_CATEGORIES_FULFILLED:
      return {
        ...state,
        categories: action.payload.data,
        isLoading: false,
      }
    case LOAD_VIDEO_LANGUAGES_FULFILLED:
      return {
        ...state,
        languages: action.payload.data,
        isLoading: false,
      }
    case LOAD_ADMIN_VIDEO_CATEGORIES_FULFILLED:
      return {
        ...state,
        adminVideoCategories: action.payload,
        isLoading: false,
      }
    case LOAD_ADMIN_VIDEO_TYPES_FULFILLED:
      return {
        ...state,
        adminVideoTypes: action.payload,
        isLoading: false,
      }
    case POST_VIDEO_FULFILLED:
      const existingVideosUpload = state?.videosUpload || []

      return {
        ...state,
        videosUpload: [action.payload, ...existingVideosUpload],
        isLoading: false,
        successMessage: i18n.t('video_context.video_created_successfully'),
      }
    case PUT_VIDEO_FULFILLED:
      const updatedVideosUpload = state?.videosUpload.map((item) => (item.id === action.payload.id ? action.payload : item))

      return {
        ...state,
        videosUpload: updatedVideosUpload,
        isLoading: false,
        successMessage: i18n.t('video_context.video_updated_successfully'),
      }
    case DELETE_VIDEO_FULFILLED:
      const remainingVideos = state?.videosUpload.filter((item) => item.id !== action.meta.id)

      return {
        ...state,
        videosUpload: remainingVideos,
        isLoading: false,
        successMessage: i18n.t('video_context.video_deleted_successfully'),
      }
    case CLEAR_VIDEOS_MESSAGES:
      return {
        ...state,
        errorMessage: null,
      }
    default:
      return state
  }
}

